var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-container"},[_c('the-navbar',{attrs:{"centered":true,"return-link":_vm.returnLink}}),_c('activity-summary')],1)}
var staticRenderFns = []

export { render, staticRenderFns }